import hasVariantByIdInCartSelector from 'modules/cart/redux/selectors/has-variant-by-id-in-cart'
import logUtil from 'utils/log'
import updateSelectedColorVariantIdVariantAction from 'modules/variant/redux/actions/update-selected-color-variant-id'
import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'
import getCurrentVariantProductSelect from 'modules/product/redux/selectors/get-current-variant'

/**
 * @param props
 * @param props.justAddedVariantId
 * @returns {(function(*, *): void)|*}
 */
export default function suggestOtherColorProductAction (props) {
  return (dispatch, getState) => {
    const { justAddedVariantId } = props
    logUtil('suggestOtherColorProductAction').debug('[start] props=', props)

    const productVariant = getCurrentVariantProductSelect(getState())
    /**
     * @type {ProductVariantCarouselInfo[]}
     */
    const variants = getVariantsProductVariantUtil(productVariant)

    if (!variants?.length) {
      logUtil('suggestOtherColorProductAction').debug('no variants')
      return
    }

    const variantIds = variants.map(item => item.variant_id)
    const variantIdsInStock = variants
      .filter(item => item?.available === true)
      .map(item => item.variant_id)
    const justAddedVariantIdIndex = variantIds.indexOf(justAddedVariantId)
    const nextVariantIds = variantIds.slice(justAddedVariantIdIndex + 1)
    const previousVariantIds = variantIds.slice(0, justAddedVariantIdIndex).reverse()
    const variantIdsToCheckIfAdded = [
      ...nextVariantIds,
      ...previousVariantIds
    ]
    const variantIdToSuggest = variantIdsToCheckIfAdded.find(variantId => {
      return !hasVariantByIdInCartSelector(variantId)(getState()) && variantIdsInStock.includes(variantId)
    })

    logUtil('suggestOtherColorProductAction').debug('variantIdToSuggest=', variantIdToSuggest)

    if (!variantIdToSuggest) {
      logUtil('suggestOtherColorProductAction').debug('no variantIdToSuggest')
      return
    }

    const shouldAddToUrl = props?.shouldAddToUrl ?? true

    dispatch(
      updateSelectedColorVariantIdVariantAction({
        variantId: variantIdToSuggest,
        shouldAddToUrl
      })
    )
    logUtil('suggestOtherColorProductAction').debug('[done]')
    return variantIdToSuggest
  }
}
